import React, { Component } from 'react'
import { Col, Container, Row, Form } from 'react-bootstrap';
import { Button } from "@mui/material";
import Select from '../../Components/PCSelect';
import WeekRangeSelect from '../../Components/WeekRangeSelect';
import axios from "axios";
import Swal from "sweetalert2";
import { money, getWeekDetails } from '../../helper';
import Detail from './Detail';
import PageHeader from '../../Pages/admin/shared/PageHeader';
import PrintButton from '../../Pages/admin/shared/PrintButton';
import FilterCard from '../../Pages/admin/shared/FilterCard';
import { ownLimit, limitOptions } from '../../helper/identity';

const SCREEN = '/report/shop-payment';

class ShopPayment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Shop_Name: [],
            // Default the filter to the current week so the dropdown opens on it
            // instead of the oldest listed week. The report still waits for "View".
            From_Week: getWeekDetails().weekId,
            To_Week: getWeekDetails().weekId,
            ShopList: [],
            showReport: false,
            ReportDetails: [],
            unapprovedWeeks: [],
            shopLocked: false,
        }
    }

    componentDidMount() {
        this.getShopList()
    }

    /* The Shop box lists only the shops the user may see (user, 2026-11-02): every shop for an
     * admin; otherwise their own shop or their pay account's partner shops. Exactly one →
     * selected and locked; several → all selected, the user may untick. */
    async getShopList() {
        const limit = ownLimit('shop', SCREEN, true);
        let all = [];
        if (!limit) {
            try {
                const res = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShops.php`);
                if (res.data.success === 1) all = res.data.data.map(shop => ({ value: shop.PC_SP_ID, label: shop.SP_NAME }));
            } catch (error) {
                console.error('getShopList error :>> ', error);
            }
        }
        const ShopList = limitOptions(all, limit);
        const shopLocked = !!limit && ShopList.length === 1;
        this.setState({ ShopList, Shop_Name: limit ? ShopList : [], shopLocked })
    }

    handleChange(fieldName, evnt) {
        let targetValue = ""
        switch (fieldName) {
            case 'Shop_Name':
                targetValue = evnt
                break;
            default:
                targetValue = evnt.target.value
                break;
        }
        this.setState({ [fieldName]: targetValue, showReport: false })
    }

    async handleViewReport() {
        if (this.state.Shop_Name.length === 0 || this.state.From_Week === "" || this.state.To_Week === "") {
            Swal.fire('Error', 'Please select at least one Shop and From / To week', 'error')
            return
        }

        this.props.toggleLoader(true)
        try {
            let shopID = "";
            for (let i = 0; i < this.state.Shop_Name.length; i++) {
                shopID += this.state.Shop_Name[i].value + ',';
            }
            let filterID = shopID.slice(0, -1);

            let formData = {
                Shop_Name: filterID,
                From_Week: this.state.From_Week,
                To_Week: this.state.To_Week
            }

            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/report/shopPayment.php`, formData);
            let resp = res.data
            if (resp.success === 1) {
                this.setState({ ReportDetails: resp.data, unapprovedWeeks: resp.unapprovedWeeks || [], showReport: true })
            } else {
                this.setState({ ReportDetails: [], unapprovedWeeks: [], showReport: false })
                Swal.fire('No Data', resp.message || 'No record found!', 'info')
            }
        } catch (error) {
            console.error('shopPayment error :>> ', error);
            Swal.fire('Error', 'Could not load the report.', 'error')
        }
        this.props.toggleLoader(false)
    }

    render() {
        return (
            <Container>
                <PageHeader breadcrumb="section" title="Shop Payment"
                    right={<PrintButton content={() => this.newRef} disabled={this.state.showReport !== true} />} />
                <FilterCard>
                    <Row style={{ alignItems: 'center' }} >
                        <Col md={3} >
                            <Form.Group className="mb-3" >
                                <Form.Label>Shop</Form.Label>
                                <Select menuPortalTarget={document.body}
                                    name="Shop_Name"
                                    isMulti
                                    menuPlacement="auto"
                                    style={{ height: '32px' }}
                                    isDisabled={this.state.shopLocked}
                                    value={this.state.Shop_Name}
                                    options={this.state.ShopList}
                                    onChange={this.handleChange.bind(this, 'Shop_Name')}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3} >
                            <Form.Group className="mb-3" >
                                <Form.Label><span>From Week</span></Form.Label>
                                <WeekRangeSelect
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    value={this.state.From_Week}
                                    onChange={this.handleChange.bind(this, "From_Week")}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3} >
                            <Form.Group className="mb-3" >
                                <Form.Label><span>To Week</span></Form.Label>
                                <WeekRangeSelect
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    value={this.state.To_Week}
                                    onChange={this.handleChange.bind(this, "To_Week")}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Button className="add-button" size="small" variant="contained" onClick={this.handleViewReport.bind(this)} >View</Button>
                        </Col>
                    </Row>
                </FilterCard>

                {this.state.showReport === true ?
                    <Detail ref={el => (this.newRef = el)} ReportDetails={this.state.ReportDetails} UnapprovedWeeks={this.state.unapprovedWeeks} money={money} />
                    :
                    ""
                }
            </Container>
        );
    }
}

export default ShopPayment;
